import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=147f1847&"
import script from "./customer.vue?vue&type=script&lang=js&"
export * from "./customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports